import { jsxs as r, jsx as e } from "react/jsx-runtime";
import { useState as d, useEffect as f } from "react";
import { createPortal as u } from "react-dom";
import p from "./titleCase.js";
import { tv as h } from "tailwind-variants";
import o from "./Icon.js";
const n = h({
  base: [
    "bg-white",
    "flex",
    "h-[3.5rem]",
    "items-center",
    "justify-center",
    "pointer-events-auto",
    "rounded-full",
    "text-neutral-900",
    "text-2xl",
    "w-[3.5rem]"
  ],
  variants: {
    isDisabled: {
      true: [
        "bg-transparent",
        "border",
        "border-neutral-500",
        "text-neutral-500"
      ]
    }
  }
}), y = ({ activeIndex: t, images: l, modal: s, setActiveIndex: a, title: i }) => {
  const [c, m] = d();
  return f(() => {
    m(!0);
  }, []), c ? u(
    /* @__PURE__ */ r(
      "div",
      {
        ...s.attr.container,
        className: "bottom-0 fixed flex items-center justify-center left-0 right-0 top-0 z-40 aria-hidden:hidden",
        children: [
          /* @__PURE__ */ e(
            "div",
            {
              ...s.attr.overlay,
              className: "absolute bg-[hsla(0,100%,0%,0.8)] h-full w-full"
            }
          ),
          /* @__PURE__ */ e("h3", { ...s.attr.title, className: "sr-only", children: i }),
          /* @__PURE__ */ r("div", { className: "gap-2 grid grid-cols-[1fr_1fr] px-5 pointer-events-none w-full z-10 desktop:gap-5 desktop:grid-cols-[1fr_min-content_1fr] desktop:items-center", children: [
            /* @__PURE__ */ e(
              "button",
              {
                "aria-label": "View previous image",
                className: n({
                  class: "col-span-1 col-start-1 row-start-2 justify-self-end desktop:row-start-1",
                  isDisabled: t === 0
                }),
                disabled: t === 0,
                onClick: () => a(t - 1),
                children: /* @__PURE__ */ e(o, { name: "arrow-left", style: "solid" })
              }
            ),
            /* @__PURE__ */ r("figure", { className: "col-span-2 col-start-1 flex flex-col items-center gap-4 pointer-events-auto desktop:col-span-1 desktop:col-start-2", children: [
              /* @__PURE__ */ e("div", { className: "max-h-[75vh] max-w-[45rem] overflow-auto desktop:max-w-none desktop:w-[70vw]", children: /* @__PURE__ */ e(
                "img",
                {
                  alt: l[t].title,
                  className: "mx-auto",
                  src: l[t].design
                }
              ) }),
              /* @__PURE__ */ r("figcaption", { className: "flex flex-col items-center text-center text-white text-sm", children: [
                /* @__PURE__ */ r("span", { children: [
                  "Image ",
                  t + 1,
                  " of ",
                  l.length
                ] }),
                /* @__PURE__ */ e("span", { className: "font-semibold", children: p(l[t].title) })
              ] })
            ] }),
            /* @__PURE__ */ e(
              "button",
              {
                "aria-label": "View next image",
                className: n({
                  isDisabled: t === l.length - 1
                }),
                disabled: t === l.length - 1,
                onClick: () => a(t + 1),
                children: /* @__PURE__ */ e(o, { name: "arrow-right", style: "solid" })
              }
            )
          ] }),
          /* @__PURE__ */ e(
            "button",
            {
              ...s.attr.closeButton,
              "aria-label": "Close modal",
              className: "absolute bg-white flex items-center h-[3.25rem] justify-center right-4 rounded-full top-4 w-[3.25rem] z-10",
              children: /* @__PURE__ */ e(o, { className: "text-3xl", name: "xmark" })
            }
          )
        ]
      }
    ),
    document.getElementById("modal-root")
  ) : null;
};
export {
  y as default
};
